
export interface ハンディ移動検索依頼型 {
  在庫部署コード: string;
  機械番号: string;
  検索移動年月日: string;
}

export interface ハンディ移動検索結果レコード型 {
  ハンディ移動シーケンス番号: number;
  更新バージョン: number;
  メーカー名: string;
  商品名: string;
  規格容量: string;
  移動年月日: Date | null;
  在庫場所部署名: string;
  移動先部署名: string;
  箱数: number;
  バラ数: number;
  入数表示: string;
  単位表示: string;
  有効期限: Date | null;
  端末名: string;
  選択: boolean;
}

export function toハンディ移動検索結果(record: ハンディ移動検索結果レコード型): ハンディ移動検索結果レコード型 {
  return {
    ハンディ移動シーケンス番号: record.ハンディ移動シーケンス番号,
    更新バージョン: record.更新バージョン,
    メーカー名: record.メーカー名,
    商品名: record.商品名,
    規格容量: record.規格容量,
    移動年月日: record.移動年月日,
    在庫場所部署名: record.在庫場所部署名,
    移動先部署名: record.移動先部署名,
    箱数: record.箱数,
    バラ数: record.バラ数,
    入数表示: record.入数表示,
    単位表示: record.単位表示,
    有効期限: record.有効期限,
    端末名: record.端末名,
    選択: true,
  };
}

export interface ハンディ移動検索結果型 {
  ハンディ移動検索結果レコード一覧: ハンディ移動検索結果レコード型[];
  アラートメッセージ: string;
}

export interface ハンディ移動削除依頼型 {
  ハンディ移動シーケンス番号: number;
  更新バージョン: number;
}

export function toハンディ移動削除依頼(record: ハンディ移動検索結果レコード型): ハンディ移動削除依頼型 {
  return {
    ハンディ移動シーケンス番号: record.ハンディ移動シーケンス番号,
    更新バージョン: record.更新バージョン,
  };
}

export interface ハンディ移動取込依頼型 {
  ハンディ移動取込依頼レコード一覧: ハンディ移動取込依頼レコード型[];
}

export interface ハンディ移動取込依頼レコード型 {
  ハンディ移動シーケンス番号: number;
  更新バージョン: number;
  移動日: Date | null;
  箱数: number;
  バラ数: number;
}

export function toハンディ移動取込依頼レコード(record: ハンディ移動検索結果レコード型): ハンディ移動取込依頼レコード型 {
  return {
    ハンディ移動シーケンス番号: record.ハンディ移動シーケンス番号,
    更新バージョン: record.更新バージョン,
    移動日: record.移動年月日,
    箱数: record.箱数,
    バラ数: record.バラ数,
  };
}


